class CONSTANTS {
  static isDev = false;
  static devRoute = 'http://localhost:5003';
  static pubRoute = 'https://zoo.alemtilsimat.com/api';
  // static pubRoute = 'https://zoodrug.medsystem360.com/api';

  static get baseRoute() {
    return this.isDev ? this.devRoute : this.pubRoute;
  }
}

export default CONSTANTS;